// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"82800443","70":"097648d7","189":"acb46f6d","275":"e67810fe","437":"6fbbbe59","545":"b48d3955","805":"61826bd4"}[chunkId] + ".chunk.css";
};